// src/utils/phone.js
// Client-side mirror of functions/core/phone.js. Keeps registration-form
// UX consistent with the server normalizer so what the parent sees on blur
// is the exact string we'll send to Twilio later.
//
// Intentionally US-only (matches our Twilio 10DLC sending tier).

/**
 * Normalize a user-entered phone string to E.164 (+1XXXXXXXXXX).
 * Returns null if the input can't be parsed as a 10-digit US number.
 */
export function toE164US(input) {
  if (input == null) return null;
  const raw = String(input).trim();
  if (!raw) return null;

  if (/^\+1\d{10}$/.test(raw)) return raw;

  const digits = raw.replace(/\D/g, '');
  if (!digits) return null;

  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  if (digits.length === 10) return `+1${digits}`;
  return null;
}

/**
 * Pretty-print an E.164 or raw-digit US number as "(555) 000-0000".
 * Returns the original string when it can't be normalized (so the field
 * never silently loses user input).
 */
export function formatUsPhone(input) {
  const e164 = toE164US(input);
  if (!e164) return String(input || '');
  const d = e164.slice(2); // strip "+1"
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

export function isValidUsE164(v) {
  return typeof v === 'string' && /^\+1\d{10}$/.test(v);
}
